"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TableListRow;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _iconsMaterial = require("@mui/icons-material");
var _material = require("@mui/material");
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _context = require("../../context");
var _FieldValue = _interopRequireDefault(require("../../FieldValue"));
var _TableListItem = _interopRequireDefault(require("../TableListItem"));
var _DragHandleIcon, _ExpandLessIcon, _ExpandMoreIcon;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function TableListRow(_ref) {
  var classes = _ref.classes,
    className = _ref.className,
    _ref$component = _ref.component,
    component = _ref$component === void 0 ? 'div' : _ref$component,
    i = _ref.i,
    id = _ref.id,
    item = _ref.item,
    style = _ref.style;
  var _useContext = (0, _react.useContext)(_context.TableListContext),
    collectionPath = _useContext.collectionPath,
    dense = _useContext.dense,
    expandableField = _useContext.expandableField,
    expandedFields = _useContext.expandedFields,
    expandMultiple = _useContext.expandMultiple,
    getLink = _useContext.getLink,
    fields = _useContext.fields,
    items = _useContext.items,
    moveListItem = _useContext.moveListItem,
    reorderable = _useContext.reorderable,
    setExpandedFields = _useContext.setExpandedFields,
    disableHover = _useContext.disableHover;
  var link = {};
  if (getLink) {
    var _getLink;
    link = (_getLink = getLink(item)) !== null && _getLink !== void 0 ? _getLink : {};
  } else if (item.href) {
    link = {
      href: item.href
    };
  } else if (item.to) {
    link = {
      to: item.to
    };
  } else if (collectionPath && item.id != null) {
    link = {
      to: "".concat(collectionPath, "/").concat(item.id)
    };
  }
  var handleExpand = function handleExpand() {
    if (expandedFields.includes(i)) {
      setExpandedFields(expandedFields.filter(function (x) {
        return x !== i;
      }));
    } else if (expandMultiple) {
      setExpandedFields([].concat((0, _toConsumableArray2.default)(expandedFields), [i]).sort());
    } else {
      setExpandedFields([i]);
    }
  };
  return /*#__PURE__*/(0, _react.createElement)(component, (0, _extends2.default)({
    className,
    id,
    style
  }, reorderable && {
    i,
    items,
    moveListItem
  }), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(classes.tableListRowItem, classes.tableListRowItem)
  }, reorderable && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(classes.tableListCell, classes.reorder, classes.tableListCell)
  }, /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    className: classes.dragButton,
    disableFocusRipple: true,
    disableRipple: true,
    disableTouchRipple: true,
    focusRipple: false,
    id: "".concat(id, "DragHandle"),
    size: dense ? 'small' : 'medium',
    tabIndex: -1
  }, _DragHandleIcon || (_DragHandleIcon = /*#__PURE__*/_react.default.createElement(_iconsMaterial.DragHandle, null)))), /*#__PURE__*/_react.default.createElement(_TableListItem.default, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.tableListCell, classes.tableListCell),
    disableHover: disableHover,
    id: "".concat(id, "Content"),
    many: fields.length > 2
  }, link), fields.map(function (_ref2) {
    var fieldKey = _ref2.fieldKey,
      fieldName = _ref2.fieldName,
      mapStateToValue = _ref2.mapStateToValue,
      fieldStyle = _ref2.style,
      translationKey = _ref2.translationKey,
      type = _ref2.type;
    if (type === 'expandable') {
      return null;
    }
    var value = fieldName.split('.').reduce(function (acc, curr) {
      return acc ? acc[curr] : acc;
    }, item);
    var typeName = type || fieldName;
    var key = fieldKey || fieldName;
    return /*#__PURE__*/_react.default.createElement("div", {
      key: key,
      className: (0, _classnames.default)(classes.tableListCellItem, classes[typeName], classes.tableListCellItem),
      id: "".concat(id, "Content-").concat(key),
      style: fieldStyle
    }, fields.length > 2 && /*#__PURE__*/_react.default.createElement(_material.Typography, {
      className: (0, _classnames.default)(classes.tableListCellItemLabel, classes.tableListCellItemLabel),
      id: "".concat(id, "Content-").concat(key, "-title")
    }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
      id: "table.".concat(translationKey)
    })), /*#__PURE__*/_react.default.createElement(_FieldValue.default, {
      dense: dense,
      id: "".concat(id, "Content-").concat(key, "-value"),
      mapStateToValue: mapStateToValue,
      type: typeName,
      value: value
    }));
  })), expandableField && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.tableListRowItemAction
  }, /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    id: "".concat(id, "ToggleExpand"),
    onClick: handleExpand,
    size: dense ? 'small' : 'medium'
  }, expandedFields.includes(i) ? _ExpandLessIcon || (_ExpandLessIcon = /*#__PURE__*/_react.default.createElement(_iconsMaterial.ExpandLess, null)) : _ExpandMoreIcon || (_ExpandMoreIcon = /*#__PURE__*/_react.default.createElement(_iconsMaterial.ExpandMore, null))))), expandableField && expandedFields.includes(i) && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(classes.tableListRowExpandable, classes.tableListRowExpandable)
  }, /*#__PURE__*/_react.default.createElement(_FieldValue.default, {
    id: "".concat(id, "ExpandableField"),
    mapStateToValue: expandableField.mapStateToValue,
    type: expandableField.type,
    value: expandableField.fieldName.split('.').reduce(function (acc, curr) {
      return acc ? acc[curr] : acc;
    }, item)
  }))));
}